<template>
  <v-list>
    <v-list-item
      class="border-bottom no-underline"
      v-for="item in items"
      :key="item.id"
      :to="`/inventory/view/${item.item_id}`"
    >
      <v-list-item-icon>
        <v-icon color="green" large v-if="item.type === 'increase'">
          mdi-plus
        </v-icon>
        <v-icon color="red" large v-else>mdi-minus</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.type }}d by: {{ item.quantity }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <strong>Reason:</strong> {{ item.note }}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          <strong>Date:</strong> {{ item.date | humanDate }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action-text>
        Amount: {{ item.amount | toMoney }} <br />
        Unit price: {{ item.unit_price | toMoney }}
      </v-list-item-action-text>
    </v-list-item>
  </v-list>
</template>

<script>
import { CURRENCY } from "../data";

export default {
  name: "AssociatedStockAdjustments",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currencyList: CURRENCY,
      headers: [
        {
          text: this.$t("header.invoice_no"),

          sortable: true,
          value: "invoice_number",
        },
        {
          text: this.$t("header.customer"),
          value: "customer.business_name",
          sortable: true,
        },
        {
          text: this.$t("header.issue_date"),
          value: "start_date",
          sortable: true,
        },
        {
          text: this.$t("header.due_date"),
          value: "end_date",
          sortable: true,
        },
        {
          text: this.$t("header.net_amount"),
          value: "net_amount",
          align: "right",
        },
        {
          text: this.$t("main.amount_due"),
          value: "amount_due",
          align: "right",
        },
        {
          text: this.$t("header.paid_status"),
          value: "paid_status",
          align: "center",
        },
        {
          text: this.$t("main.created_at"),
          value: "created_at",
        },
      ],
    };
  },
  methods: {
    fxCurrency(currency) {
      const fx = this.currencyList.find((c) => c.cc === currency);
      return fx ? fx.symbol : this.baseSymbol;
    },
  },
};
</script>

<style scoped>
.no-underline {
  text-decoration: none;
}
</style>
